import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

function Promotion() {
  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Card>
            <Card.Header>
              <Card.Title as="h4">Promotion</Card.Title>
            </Card.Header>
            <Card.Body>
              <p>Promotion content goes here.</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Promotion;